import * as dateFns from 'date-fns';
import type { DateUtils } from '@/modules/tasks-list/domain/task-expiration/DateUtils';

export class DateFnsUtils implements DateUtils {
  isToday(date: Date): boolean {
    return dateFns.isToday(date);
  }
}
